const SYSTEM_IDS = { system: 'Viatik', admin: 'Soporte Viatik' }

export function fullName(metadata) {
  if (!metadata) return ''
  return [metadata.first_name, metadata.last_name].filter(Boolean).join(' ').trim()
}

export function userFullName(user) {
  return fullName(user && user.user_metadata)
}

export function passengerName(passenger) {
  if (!passenger) return ''
  return userFullName(passenger.user) || (passenger.companion && passenger.companion.first_name) || ''
}

export function isSystemId(userId) {
  return Object.prototype.hasOwnProperty.call(SYSTEM_IDS, userId)
}

export function makeAuthorResolver({ chatUsers, driverId }) {
  const byId = new Map((chatUsers || []).map(u => [u.user_id, u]))

  return (userId, channel) => {
    const known = byId.get(userId)
    const channelUser = ((channel && channel.users) || []).find(u => u.user_id === userId)
    const name = fullName(known) || (channelUser && channelUser.name) || SYSTEM_IDS[userId] || 'Usuario'
    const picture = (known && known.picture) || (channelUser && channelUser.picture) || null
    const role = isSystemId(userId) ? null : userId === driverId ? 'conductor' : 'pasajero'
    return { name, picture, role }
  }
}
